
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#54565a","d":"M6.303 12.937l1.616 14.24c.087.677 3.353 2.9 8.081 2.903 4.728-.003 7.995-2.226 8.082-2.903l1.616-14.24c-2.469 1.381-6.161 2.036-9.697 2.036s-7.228-.655-9.697-2.036zm14.342-8.8l-1.26-1.397c-.486-.691-1.014-.82-2.041-.82h-2.686c-1.028 0-1.555.129-2.042.82l-1.26 1.397c-3.77.659-6.502 2.406-6.502 3.693v.25c0 2.268 4.991 4.107 11.147 4.107s11.147-1.838 11.147-4.107v-.25c0-1.287-2.732-3.034-6.502-3.693zm-1.61 3.267L17.199 5.44h-2.398l-1.836 1.964h-2.493s2.732-3.256 3.097-3.697a1.12 1.12 0 01.909-.467h.025-.001 3.02c.373 0 .704.183.908.464l.002.003c.364.442 3.097 3.697 3.097 3.697z"}})])
          )
        }
      }
    